var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-white py-5 border-light border-bottom" },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "secondary-heading" }, [
          _vm._v("\n      " + _vm._s(_vm.articleData.category) + "\n    ")
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "h2" }, [
          _vm._v("\n      " + _vm._s(_vm.articleData.title) + "\n    ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wf-article-date" }, [
          _vm._v("\n      " + _vm._s(_vm.articleData.date) + "\n    ")
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "wf-article-description-top",
          domProps: { innerHTML: _vm._s(_vm.articleData.description) }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wf-article-media" },
          [
            _c("pc-article-media", {
              attrs: {
                src: _vm.articleData.media1.src.replace("~", ""),
                alt: _vm.articleData.media1.alt,
                caption: _vm.articleData.media1.caption
              }
            }),
            _vm._v(" "),
            _c("pc-article-media", {
              attrs: {
                src: _vm.articleData.media2.src.replace("~", ""),
                alt: _vm.articleData.media2.alt,
                caption: _vm.articleData.media2.caption
              }
            }),
            _vm._v(" "),
            _c("pc-article-media", {
              attrs: {
                src: _vm.articleData.media3.src.replace("~", ""),
                alt: _vm.articleData.media3.alt,
                caption: _vm.articleData.media3.caption
              }
            }),
            _vm._v(" "),
            _c("pc-article-media", {
              attrs: {
                src: _vm.articleData.media4.src.replace("~", ""),
                alt: _vm.articleData.media4.alt,
                caption: _vm.articleData.media4.caption
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "wf-article-description-bottom",
          domProps: { innerHTML: _vm._s(_vm.articleData.descriptionBottom) }
        }),
        _vm._v(" "),
        _vm.articleData.primaryTag || _vm.articleData.secondaryTag
          ? _c("div", { staticClass: "wf-article-tags mt-5" }, [
              _c("div", { staticClass: "call-to-action-links" }, [
                _c("h4", { staticClass: "label mb-2" }, [
                  _vm._v("In this article:")
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "list-unstyled d-flex flex-row flex-wrap mx-n1"
                  },
                  [
                    _vm.articleData.primaryTag
                      ? _c("li", { staticClass: "p-1" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-white shadow-sm h-100 w-100",
                              attrs: {
                                href: _vm.tagName(_vm.articleData.primaryTag)
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.articleData.primaryTag) +
                                  "\n\n              "
                              ),
                              _c("span", {
                                staticClass:
                                  "png-icon png-icon-icons-glyph--k-arrow-right-sm"
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.articleData.secondaryTag
                      ? _c("li", { staticClass: "p-1" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-white shadow-sm h-100 w-100",
                              attrs: {
                                href: _vm.tagName(_vm.articleData.secondaryTag)
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.articleData.secondaryTag) +
                                  "\n\n              "
                              ),
                              _c("span", {
                                staticClass:
                                  "png-icon png-icon-icons-glyph--k-arrow-right-sm"
                              })
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ])
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }